import CryptoJS from 'crypto-js'
import Cookie from 'js-cookie'
import FingerprintJS from '@fingerprintjs/fingerprintjs'

const parseJWT = (token: string) => {
  try {
    if (!token) return null
    const parts = token.split('.')
    if (parts.length !== 3) return null

    // Base64解码payload部分
    const payload = parts[1]
    // 处理Base64 URL安全编码
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/')
    const decoded = atob(base64)
    return JSON.parse(decoded)
  } catch (error) {
    console.error('JWT解析失败:', error)
    return null
  }
}

const getFingerprint = async () => {
  const fp = await FingerprintJS.load()
  const result = await fp.get()
  const visitorId = result.visitorId

  return visitorId
}

export const generateDeviceIdByFingerprint = async () => {
  let deviceId = Cookie.get('C5DeviceId')
  if (deviceId) {
    return deviceId
  }

  deviceId = await getFingerprint()

  Cookie.set('C5DeviceId', deviceId)

  return deviceId
}

const generateSign = ({
  pathname,
  accessToken,
  timestamp,
  method
}: {
  pathname: string
  accessToken: string
  timestamp: number
  method: string
}) => {
  // 获取pathname 并规范化路径，类似Java的URIBuilder.normalize()
  // 确保前面有斜杠，后面也有斜杠，处理重复斜杠
  let normalizedPath = pathname
  // 去除开头多余的斜杠，只保留一个
  normalizedPath = normalizedPath.replace(/^\/+/, '/')
  // 去除结尾多余的斜杠，只保留一个
  normalizedPath = normalizedPath.replace(/\/+$/, '/')
  // 确保以斜杠开头
  if (!normalizedPath.startsWith('/')) {
    normalizedPath = '/' + normalizedPath
  }
  // 确保以斜杠结尾
  if (!normalizedPath.endsWith('/')) {
    normalizedPath = normalizedPath + '/'
  }

  // 获取method 大写
  const A = method.toLocaleUpperCase()

  // 规范化后的请求路径
  const B = normalizedPath

  // MagicCode 魔数
  const C = normalizedPath.length % 6

  // 请求时间戳
  const D = timestamp

  // 解析JWT获取用户信息
  const jwtPayload = parseJWT(accessToken)

  // 密钥 - 可以使用JWT中的特定字段，如用户ID等
  const E = jwtPayload?.sct

  const sign = CryptoJS.MD5(A + '|' + B + '|' + C + '|' + D + '|' + E).toString()
  console.log('sign', A + '|' + B + '|' + C + '|' + D + '|' + E, sign)
  return sign
}

export function useCustomHeaders() {
  const timestamp = +new Date()

  const accessToken = useCookie('C5AccessToken').value || useCookie('H5_C5_AccessToken').value || ''
  const userAgent = useDevice().userAgent

  const headers = {
    'accept-language': 'zh-CN',
    'x-access-token': accessToken,
    'x-device-id': '',
    'x-start-req-time': String(timestamp),
    'x-source': isInApp ? (useCookie('C5Channel').value === 'iOS' ? '3' : '2') : '4',
    'x-app-channel': useCookie('C5Channel').value || 'iOS',
    'x-app-version-code': useCookie('C5AppVersion').value || '401000',
    'x-ua': userAgent,
    'x-sign': '',
    'x-sem-channel': '',
    'x-referral-url': ''
  }

  const douyuTag = useCookie('douyuTag').value || ''
  const from = useCookie('NC5_sem_from').value || ''
  const keyword = useCookie('NC5_sem_keyword').value || ''
  const clickExt = useCookie('NC5_sem_clickExt').value || ''
  const bdvid = useCookie('bd_vid').value || ''
  const sem360id = useCookie('NC5_sem360id').value || ''
  const refererUrl = useCookie('refererurl').value || ''
  const source = useCookie('NC5_activity_from').value || ''

  if (douyuTag || from || keyword || bdvid || sem360id || source) {
    headers['x-sem-channel'] = `${douyuTag || from || source};${keyword};${bdvid || clickExt || sem360id}`
    headers['x-referral-url'] = refererUrl
  }

  return {
    get: ({ url, method, deviceId }: { url?: string; method?: string; deviceId?: string }) => {
      headers['x-sign'] = generateSign({
        pathname: url || '',
        accessToken,
        timestamp,
        method: method || 'GET'
      })
      headers['x-device-id'] = deviceId || ''
      return headers
    }
  }
}
